/**
 * Timeout-Warnung Modal
 * 
 * Legacy-Referenz: /opt/wash-ops/src/components/TimeoutWarning.tsx
 * 
 * Zeigt Countdown vor automatischem Logout.
 * User kann Sitzung verlängern durch Klick.
 */

import { Clock } from 'lucide-react';

interface TimeoutWarningProps {
  show: boolean;
  remainingSeconds: number;
  onDismiss: () => void;
}

export function TimeoutWarning({ show, remainingSeconds, onDismiss }: TimeoutWarningProps) {
  if (!show) return null;

  // Format: mm:ss fuer Konsistenz mit Header-Anzeige
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeDisplay = minutes > 0 
    ? `${minutes}:${seconds.toString().padStart(2, '0')}`
    : `${seconds} Sek.`;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="max-w-sm w-full bg-white rounded-lg shadow-2xl">
        <div className="pt-6 px-6 pb-6 text-center">
          <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center mx-auto mb-4">
            <Clock className="w-8 h-8 text-orange-600" />
          </div>
          <h2 className="text-xl font-bold mb-2">Noch aktiv?</h2>
          <p className="text-slate-600 mb-2">
            Abmeldung in
          </p>
          <p className="text-4xl font-bold text-orange-600 mb-6">
            {timeDisplay}
          </p>
          <button 
            className="w-full min-h-[56px] text-lg bg-slate-900 hover:bg-slate-800 text-white rounded-md font-medium transition-colors"
            onClick={onDismiss}
          >
            Ja, weiterarbeiten
          </button>
        </div>
      </div>
    </div>
  );
}
